import React from 'react';
import Reflux from 'reflux';
import { Row, Col } from 'bootstrap';
import FSObjectIcon from 'shared/components/event/fsObjectIcon';
import Spinner from 'shared/components/misc/simpleSpinner.jsx';
import EventShowListStore from 'flux/stores/EventShowListStore';
import RouteActions from 'flux/actions/RouteActions';
import moment from 'moment-timezone';
import s3Urls from 'shared/constants/s3';

import {
  NameHeaderCell,
  DateHeaderCell,
  TypeHeaderCell,
} from 'shared/components/event/fsObjectListHeaderRow';

import { IconBar as SavedIconBar } from 'main/components/show/singleEventSavedList';
import { IconBar as TemplateIconBar } from 'main/components/show/singleEventTemplateList';

// NOTE THIS FILE HAS MANY PROP TYPE VIOLATIONS
// AND ALL ARE DISABLED BY THE COMMENT BELOW.
/* eslint-disable react/prop-types */

/**
 * Show template/archive list HOC
 *
 * @param stateKey
 * @param archived
 * @returns {*}
 */
export default (stateKey, archived = false) => {
  return React.createClass({
    mixins: [
      Reflux.connectFilter(EventShowListStore, 'shows', (st) =>
        st.get(stateKey),
      ),
    ],

    displayName: 'EventObjectList_' + stateKey,

    render() {
      let shows = this.state.shows;

      if (!shows) return this._getLoadingNode();

      return (
        <Row>
          <Col lg={24}>{this._getTableNode()}</Col>
        </Row>
      );
    },

    _getLoadingNode() {
      return <Spinner top="50%" left="50%" />;
    },

    _getTableNode() {
      return (
        <div className="event-folder-list">
          {this._getHeaderNode()}
          {this._getBodyNode()}
        </div>
      );
    },

    _getHeaderNode() {
      return (
        <Row className="event-list-header">
          <TypeHeaderCell />
          <NameHeaderCell />
          <DateHeaderCell />
        </Row>
      );
    },

    _getBodyNode() {
      let list = this.state.shows,
        { teamId, eventId } = this.props;

      let rowNodes = list
        .filter((item) => item.get('archived') === archived)
        .map((item) => {
          return <ListItem teamId={teamId} eventId={eventId} item={item} />;
        });

      if (!rowNodes.size) {
        rowNodes = this._getEmptyStateNode(stateKey === 'showTemplates');
      }

      return <div>{rowNodes}</div>;
    },

    _getEmptyStateNode(template) {
      let props = {
        headerText: "You don't have anything saved",
        subHeaderText: (
          <span>
            Saved shows are a great way to have handy backups. &nbsp;
            <a onClick={() => window.open('https://shoflo.tv/saved-shows/')}>
              Learn more.
            </a>
          </span>
        ),
        graphicUrl: s3Urls.emptySavedGraphic,
      };

      if (template) {
        props = {
          headerText: "You don't have any templates",
          subHeaderText: (
            <span>
              Templates are a great way to create a solid base for future shows.
              &nbsp;
              <a
                onClick={() =>
                  window.open('https://shoflo.tv/customtemplates/')
                }
              >
                Learn more.
              </a>
            </span>
          ),
          graphicUrl: s3Urls.emptyTemplatesGraphic,
        };
      }

      return <EmptyState {...props} />;
    },
  });
};

const EmptyState = ({ headerText, subHeaderText, graphicUrl }) => {
  return (
    <div className="empty-list-placeholder">
      <h2>{headerText}</h2>

      <h4>{subHeaderText}</h4>
      <br />
      <img src={graphicUrl} />
    </div>
  );
};

const ListItem = ({ item, teamId, eventId }) => {
  let onClick = () =>
    RouteActions.goToShowDisplayType(
      { teamId, eventId, showId: item.get('_id') },
      item.get('displayType'),
    );

  return (
    <Row className="block">
      <div className={'event-list-item-readonly'}>
        <TypeCell item={item} />
        <NameCell name={item.get('title')} onClick={onClick} />
        <DateCell date={item.get('modifiedOn')} />
        <IconCell item={item} teamId={teamId} eventId={eventId} />
      </div>
    </Row>
  );
};

class TypeCell extends React.Component {
  render() {
    let { item } = this.props;

    return (
      <Col
        lgOffset={1}
        lg={2}
        mdOffset={1}
        md={3}
        sm={4}
        xs={5}
        className="event-folder-list-type-cell"
      >
        <FSObjectIcon item={item} />
      </Col>
    );
  }
}

class NameCell extends React.Component {
  render() {
    let { name, onClick } = this.props;

    return (
      <Col lg={7} md={8} sm={12} xs={12}>
        <div>
          <a onClick={onClick}>{name}</a>
        </div>
      </Col>
    );
  }
}

class DateCell extends React.Component {
  render() {
    let { date } = this.props;

    return (
      <Col lg={5} md={5} sm={8} className="hidden-xs">
        {moment(date).format('dddd, MMMM DD')}
      </Col>
    );
  }
}

class IconCell extends React.Component {
  render() {
    let { item } = this.props;

    let IconBarType = item.get('template') ? TemplateIconBar : SavedIconBar;

    return (
      <Col lg={5} md={5} sm={7} xs={7} className="hidden-xs">
        <IconBarType {...this.props} />
      </Col>
    );
  }
}
